import { DealersService } from '../../../services/dealers.service';
import { PERMISSIONS_DEALER } from 'src/config';
import { USER_ACTIONS } from '../../../utils/enums/user-store-actions.enum';

const EMPTY_DEALER_VALUES = ['null', 'undefined'];

// Field users need both district and dealership selected to see any menu item.
export function isNavigationAvailable(
    accessUser?: boolean,
    selectedDistrict?: string,
    dealer?: string,
): boolean {
    if (!dealer) return false;
    if (!accessUser) return true;

    return Boolean(selectedDistrict) && !EMPTY_DEALER_VALUES.includes(dealer);
}

export async function initializeDealer(
    dealer: string,
    dispatch: Function,
    loadingHandler: Function,
) {
    try {
        if (dealer) {
            loadingHandler(true);
            const service = new DealersService();
            const res = await service.getDealerData(dealer);
            if (res && res.data) {
                const { dealerData } = res.data;

                const phone = dealerData?.dealer?.phoneNumber;
                if (phone) {
                    dealerData.dealer.phoneNumber =
                        extractPhoneNumber(phone).trim();
                }

                dispatch({
                    type: USER_ACTIONS.SET_DEALER_DATA,
                    payload: dealerData,
                });
                if (dealerData.fieldUserPermissions) {
                    sessionStorage.setItem(
                        PERMISSIONS_DEALER,
                        JSON.stringify(dealerData.fieldUserPermissions),
                    );
                }
                loadingHandler(false);
            } else {
                alert('An error occur');
                console.error(res);
                loadingHandler(false);
            }
            loadingHandler(false);
        }
    } catch (e) {
        console.error('Error', e);
        loadingHandler(false);
    }
}

function extractPhoneNumber(input: string) {
    const match = input.match(/\(\d{3}\)\s\d{3}-\d{4}/);
    return match ? match[0] : input;
}
